module.exports = __webpack_public_path__ + "img/card_vernazzaheritage_background.4290beed.png";